import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "v-card-widget" } },
    [
      _c(
        VCard,
        { attrs: { outlined: "" } },
        [
          _vm.enableHeader
            ? _c(
                VToolbar,
                {
                  staticClass: "toolbar-title",
                  attrs: { color: "transparent", dense: "", flat: "" },
                },
                [
                  _c(VToolbarTitle, [
                    _c("h4", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.enableHeader ? _c(VDivider) : _vm._e(),
          _c(VCardText, [_vm._t("widget-content")], 2),
          _vm.enableActions ? _c(VDivider) : _vm._e(),
          _vm.enableActions
            ? _c(
                VCardActions,
                [_c(VSpacer), _vm._t("widget-actions")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }